export default function MultiSelectField({
  field,
  value = [],
  onChange,
  error,
  disabled,
}) {
  const selectedValues = Array.isArray(value) ? value : [];

  const handleToggle = (optionValue) => {
    if (selectedValues.includes(optionValue)) {
      onChange(
        field.key,
        selectedValues.filter((item) => item !== optionValue),
      );
    } else {
      onChange(field.key, [...selectedValues, optionValue]);
    }
  };

  return (
    <div className="dynamic-field-control">
      <label className="dynamic-field-control__label">
        {field.label}
        {field.required && (
          <span className="dynamic-field-control__required">*</span>
        )}
      </label>

      <div className="dynamic-field-control__options">
        {(field.options || []).map((option) => {
          const optionValue = option.value || option;

          return (
            <label key={optionValue} className="dynamic-field-control__option">
              <input
                type="checkbox"
                checked={selectedValues.includes(optionValue)}
                disabled={disabled}
                onChange={() => handleToggle(optionValue)}
              />
              <span>{option.label || option}</span>
            </label>
          );
        })}
      </div>

      {error && <span className="dynamic-field-control__error">{error}</span>}
    </div>
  );
}
